{{ config.data.message | translate }}

<div class="flex justify-end gap-2 mt-6">
  @for (action of config.data.actions; track $index) {
    <p-button
      [label]="action.title | translate"
      [severity]="action.severity ?? 'secondary'"
      (onClick)="closeDialog(action.action)"
    />
  }
</div>
